/** Длительность в секундах → «2д 4ч» / «4ч 30м» / «12м». */
export function formatDuration(secs) {
  if (!secs) return null
  const d = Math.floor(secs / 86400)
  const h = Math.floor((secs % 86400) / 3600)
  const m = Math.floor((secs % 3600) / 60)
  if (d) return `${d}д ${h}ч`
  if (h) return `${h}ч ${m}м`
  return `${m}м`
}

/** Дата и время в локальном формате. */
export function formatDateTime(value) {
  if (!value) return null
  return new Date(value).toLocaleString('ru', { dateStyle: 'short', timeStyle: 'short' })
}

export function formatDate(value) {
  if (!value) return null
  return new Date(value).toLocaleDateString('ru', { dateStyle: 'short' })
}
